

import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get, pad } from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import "./BlockManagement.css";
import Overlay from "../../components/Overlay";
import { Modal } from "../../components/Modal";
import { extractDate, subadminAccessChange } from "../../utils/functions";

// Mui & material UI
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import SearchBar from "material-ui-search-bar";
import Pagination from '@mui/material/Pagination';
import { makeStyles } from "@material-ui/core/styles";
import PaginationItem from '@mui/material/PaginationItem';

import {
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination
} from "@material-ui/core";

// icons 
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";
import { LuPencilLine } from "react-icons/lu";
import { FiEye } from "react-icons/fi";
import { IoIosArrowRoundBack } from "react-icons/io";

import EyeIcon from "../../assets/images/eye-tick.png";
import UserIcon from "../../assets/images/users-check.png";

// Elements

import {
    DashboardContainer,
    DashboardWrapper,
    DashboardHeading,
    SearchFilterContainer,
    DashHeading,
    Button,
    DeleteButton,
    ProfileDetailForm,
    SelectedColumnContainer,
} from "./BlockElement";


const useStyles = makeStyles((theme) => ({
     table: {
        borderCollapse: 'separate',
        borderSpacing: '0 6px', // adds vertical spacing between rows
    },
    tableMainContainer: {
        maxHeight: "50vh",
        overflowX: "auto",
        overflowY: "auto",
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "4px",
    },
    tableHeadingRow: {
        position: "sticky", // Make header sticky
        top: 0, // Stick to the top
        zIndex: 1, // Ensure it appears above other rows
        background: "#FFFFFF", // Header background color
        // border: "1px solid #D9E3D9",

    },

    tableBodyRow: {
        border: "1px solid #D9E3D9",
        "&:hover": {
            backgroundColor: "#f5f5f5",
        },
    },
    tableHeadingCell: {
        padding: "0.3rem 1rem !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#26344E",
        fontWeight: 500,
        // borderBottom: "1px solid #D9E3D9",
        whiteSpace: "nowrap",
    },
    textMiddle: {
        padding: "0.3rem 1rem !important",
        verticalAlign: "middle !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#1C2D28",
        backgroundColor: "#FFFFFF",
    },
    tablePaginationStyle: {
        border: "1px solid #0000001a",
        borderRadius: "0rem 0rem 0.4rem 0.4rem",
        overflowY: "hidden",
    },
    paginationContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

    }
}));


const BlockManagementDetails = ({ setUsers, userData }) => {

    const param = useParams();
    const classes = useStyles();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [userHistoryDetails ,setUserHistoryDetails] = useState();


    // For Pagination
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalDocs, setTotalDocs] = useState(0);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(1); // Reset to the first page when rows per page change
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage); // Update page and trigger data fetch
    };



    // Get user data
    useEffect(() => {
        getUserHistoryDetails(page);
    }, [page, rowsPerPage,]);

    // userViewHistory
   
     const getUserHistoryDetails = async () => {
       setIsLoading(true);
   
       try {
         const { data } = await axios.get(`/private/getBlackistWordHistory/${param?.id}`);
         setUserHistoryDetails(data?.data);
       } catch (error) {
         if (error?.response?.status === 901) {
           subadminAccessChange(navigate);
           toast.error(`${error.response.data?.message}`, {
             position: "top-right",
           });
         } else if (error?.response?.status === 419) {
            toast.error(`${error.response.data?.message}`, {
                position: "top-right",
              });
         }
          else {
           console.log("error", error?.response);
         }
       } finally {
         setIsLoading(false);
       }
     };


    return (
        <>
            <DashboardContainer>
                <DashboardWrapper>
                    <ProfileDetailForm>
                        <DashboardHeading 
                        onClick={() => navigate("/blockManagement")}
                        >                    
                        <IoIosArrowRoundBack style={{ fontSize: "2rem", cursor: "pointer" }} /> Back                         
                        </DashboardHeading>

                        <TableContainer
                            className={classes.tableMainContainer}
                        >
                            <Table  className={classes.table}>
                                <TableHead>
                                    <TableRow className={classes.tableHeadingRow} >
                                        <TableCell className={classes.tableHeadingCell}>
                                            S.No
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Created On
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Sub Admin Name
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Word Changes From
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Word Changes to
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                {userHistoryDetails && userHistoryDetails.length > 0 ? (
                                    <>
                                        <TableBody>
                                            {userHistoryDetails.map((user, index) => (
                                                <TableRow className={classes.tableBodyRow} key={user._id}>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{index + 1 + rowsPerPage * (page - 1)}</div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{extractDate(get(user, "createdAt", "---"))}</div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem", fontSize: "14px", cursor: "pointer", color: "#5088FB" }}>
                                                        {get(user, "updatedBy", "---")}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{ textTransform: "capitalize", color: "#484848", fontSize: "14px", fontWeight: "700" }}
                                                        >{get(user, "wordChangesFrom", "---")}</div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{ textTransform: "capitalize", color: "#484848", fontSize: "14px", fontWeight: "700" }}>
                                                            {get(user, "wordChangesTo", "---")}
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </>
                                ) : (
                                    <>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={13} align="center" style={{ padding: "2rem" }}>
                                                    <DashHeading style={{ textAlign: "center", padding: "2rem" }}>No Data Found !!</DashHeading>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </>
                                )}
                            </Table>
                        </TableContainer>
                        {/* <Stack spacing={2} className={classes.paginationContainer}>
                            <Pagination
                                count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                                page={page}
                                onChange={(event, value) => handleChangePage(event, value)} // Update page
                                renderItem={(item) => (
                                    <PaginationItem
                                        slots={{ previous: HiMiniArrowLeft, next: HiMiniArrowRight }}
                                        {...item}
                                    />
                                )}
                            />
                        </Stack> */}
                    </ProfileDetailForm>
                </DashboardWrapper>
            </DashboardContainer>
            {isLoading && <Overlay />}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        locationData: state.locations,
        defaultState: state.defaultState,
        sidebar: state.sidebar,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setUsers: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_USER,
                updatedUser: updatedValue,
            });
        },
        setDefaultState: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_DEFAULT,
                updateDefault: updatedValue,
            });
        },
        setSidebar: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_SIDEBAR,
                updateSidebar: updatedValue,
            });
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BlockManagementDetails);





